export default "__VITE_ASSET__8c7d41cb__"